import React from "react";

const Footer = () => (
  <footer>
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-6 footer-nameApp">
          APLIGO | CPA - CUSTOMER PAYMENT ALLOCATION
        </div>
        <div className="col-xs-12 col-sm-6 footer-copy">{`© CEPSA ${new Date().getFullYear()}`}</div>
      </div>
    </div>
  </footer>
);

export default Footer;
